module.exports = __webpack_public_path__ + "static/media/OpenSans.07d1a425.eot";